import type { DefaultTheme } from 'styled-components';

import { FONT_FAMILY, tokens } from './tokens';

export const defaultTheme: DefaultTheme = {
	tokens,
	colors: {
		primaryLight: tokens.brand.background,
		primary: tokens.text.primary,
		primaryVibrant: tokens.brand.text,
		secondary: tokens.text.primary,

		antracite: tokens.text.primary,
		slateBlue: tokens.text.secondary,
		darkGray: tokens.text.secondary,
		lightGray: tokens.surface.primary,
		midGray: tokens.surface.secondary,

		blue: tokens.info.icon,
		lightBlueDark: tokens.border.strong,
		lightBlue: tokens.border.subtle,
		lightBlueLight: tokens.surface.primary,

		whiteBlue: tokens.surface.secondary,
		whiteBlueLight: tokens.surface.primary,
		white: tokens.surface.white,
		whiteGray: tokens.surface.primary,
		whiteGrayLight: tokens.surface.secondary,

		whiteTransparent: 'rgba(255, 255, 255, 0.7)',
		WhiteTransparantHard: 'rgba(255, 255, 255, 0.8)',
		WhiteTransparantMediumHard: 'rgba(255, 255, 255, 0.65)',
		WhiteTransparantMedium: 'rgba(255, 255, 255, 0.5)',
		WhiteTransparantMediumSoft: 'rgba(255, 255, 255, 0.35)',
		WhiteTransparantSoft: 'rgba(255, 255, 255, 0.2)',

		black: '#000000',

		danger: tokens.error.icon,
		dangerDark: tokens.error.text,
		warning: tokens.warning.icon,
		success: tokens.success.icon,
		green: tokens.success.icon,
		greenDark: tokens.success.text,

		yellow: tokens.warning.icon,
		purple: tokens.text.primary,
		lightPurple: tokens.brand.background,

		pink: tokens.brand.text,
		red: tokens.error.icon,
		transparent: 'transparent',

		employee: '#32C5FF',
		manager: '#F7B500',
	},
	images: {
		loginBackground: '/images/treams-login.png',
		logo: '/images/treams_logo.svg',
		lineGradient: 'linear-gradient(90deg, #9906B7 0%, #4840BE 100%)',
	},

	fontFamilies: {
		paragraph: FONT_FAMILY,
		heading: FONT_FAMILY,
	},

	isTrialEnvironment: false,
	hasAnnouncementBanner: false,
};

export const placeholderTheme = {
	...defaultTheme,
	colors: {
		...defaultTheme.colors,
		primaryLight: defaultTheme.colors.lightBlueDark,
		primary: defaultTheme.colors.lightBlueDark,
		secondary: defaultTheme.colors.lightBlueDark,
	},
	images: {
		...defaultTheme.images,
		logo: undefined,
		lineGradient: `linear-gradient(90deg, ${defaultTheme.colors.lightBlueDark} 0%, ${defaultTheme.colors.lightBlueDark} 100%);`,
	},
};
